<template>
    <div class="info-notification">
        <p class="m-0">{{ data.content }}</p>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.info-notification {
    font-size: 0.9rem;
    color: #333;
}
</style>
